module.exports = __webpack_public_path__ + "static/126-b806f82520379f068430d2bfdf441e2c.jpg";